module.exports = __webpack_public_path__ + "static/img/system-1.da7de210.png";